import { render, staticRenderFns } from "./QRcode.vue?vue&type=template&id=36beb834&scoped=true"
import script from "./QRcode.vue?vue&type=script&lang=js"
export * from "./QRcode.vue?vue&type=script&lang=js"
import style0 from "./QRcode.vue?vue&type=style&index=0&id=36beb834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36beb834",
  null
  
)

export default component.exports